/* ================================================================
   Email-my-results — shared capture for the Size Helper and the
   Technique Match result states (interactive-elements strategy:
   decision tools stay UNGATED; the result offers an optional,
   prominent "email me this" instead).

   Submits to Klaviyo's public client API (no key needed — public
   company_id, same as the onsite popup):
     1. client/subscriptions → subscribes to the main Email List
        (single opt-in) with the result saved as profile properties.
     2. client/events → fires "Requested Size Helper Result" /
        "Requested Technique Match" carrying the full result, so a
        flow can send the actual results email.
   ⚠ The results-email FLOW must exist in Klaviyo before this goes
   live, or subscribers get nothing (see handoff).
   ================================================================ */
(function () {
  'use strict';

  var COMPANY_ID = 'VZ7Hz7';
  var LIST_ID = 'Xes4J2'; /* "Email List" — same list as the popup */
  var REVISION = '2024-10-15';

  function post(path, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) { throw new Error('Klaviyo ' + path + ' ' + res.status); }
    });
  }

  function clean(el) {
    return el && el.textContent ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  /* Read the rendered result straight from the DOM — no coupling to
     the widgets' internal state. */
  function collect(widget) {
    if (widget.hasAttribute('data-size-helper')) {
      var roomChip = widget.querySelector('[data-jsh-room].is-selected');
      var shopA = widget.querySelector('[data-jsh-shop]');
      return {
        metric: 'Requested Size Helper Result',
        source: 'Size Helper — email my results',
        props: {
          'Size Helper Result': clean(widget.querySelector('[data-jsh-size]')).replace(/^Your size:\s*/i, ''),
          'Size Helper Room': clean(roomChip)
        },
        event: {
          Result: clean(widget.querySelector('[data-jsh-size]')),
          Why: clean(widget.querySelector('[data-jsh-why]')),
          Room: clean(roomChip),
          'Shop URL': shopA ? shopA.href : '',
          'Source Page': window.location.pathname
        }
      };
    }
    var shopB = widget.querySelector('[data-jtm-shop]');
    return {
      metric: 'Requested Technique Match',
      source: 'Technique Match — email my results',
      props: {
        'Technique Match Result': clean(widget.querySelector('[data-jtm-name]'))
      },
      event: {
        Result: clean(widget.querySelector('[data-jtm-name]')),
        Why: clean(widget.querySelector('[data-jtm-why]')),
        'Shop URL': shopB ? shopB.href : '',
        'Source Page': window.location.pathname
      }
    };
  }

  function init(box) {
    if (box.__jerBound) { return; }
    box.__jerBound = true;

    var form = box.querySelector('[data-jer-form]');
    var input = box.querySelector('.jsh__email-input');
    var button = box.querySelector('.jsh__email-btn');
    var note = box.querySelector('.jsh__email-note');
    var done = box.querySelector('.jsh__email-done');
    var error = box.querySelector('.jsh__email-error');
    var widget = box.closest('[data-size-helper], [data-technique-match]');
    if (!form || !input || !button || !widget) { return; }

    var sending = false;
    var buttonLabel = button.textContent;

    function setState(state) {
      form.hidden = state === 'done';
      if (note) { note.hidden = state === 'done'; }
      if (done) { done.hidden = state !== 'done'; }
      if (error) { error.hidden = state !== 'error'; }
      button.disabled = state === 'sending';
      button.textContent = state === 'sending' ? 'Sending…' : buttonLabel;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending) { return; }
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        input.focus();
        return;
      }

      var r = collect(widget);
      sending = true;
      setState('sending');

      var subscription = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: r.source,
            profile: {
              data: { type: 'profile', attributes: { email: email, properties: r.props } }
            }
          },
          relationships: { list: { data: { type: 'list', id: LIST_ID } } }
        }
      };

      var event = {
        data: {
          type: 'event',
          attributes: {
            properties: r.event,
            metric: { data: { type: 'metric', attributes: { name: r.metric } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      };

      Promise.all([post('subscriptions', subscription), post('events', event)])
        .then(function () {
          sending = false;
          setState('done');
          /* Link the onsite session to the profile so Klaviyo
             tracking (viewed product etc.) attaches from here on. */
          try {
            if (window.klaviyo && window.klaviyo.identify) {
              window.klaviyo.identify({ email: email });
            }
          } catch (err) { /* non-essential */ }
        })
        .catch(function () {
          sending = false;
          setState('error');
        });
    });

    /* If they restart the widget for a new result, offer the form
       again for the new answer. */
    var restart = widget.querySelector('[data-jsh-restart], [data-jtm-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        sending = false;
        setState('idle');
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-jer]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-jer]').forEach(init);
  });
})();
